import type { UnknownRecord } from "type-fest";

export type AssertionContext = UnknownRecord;

export class AssertionError extends Error {
  private readonly context?: AssertionContext;
  constructor(message: string, context?: AssertionContext) {
    super(message);
    this.name = "AssertionError";
    this.context = context;
  }

  toJSON(): UnknownRecord {
    return {
      name: this.name,
      message: this.message,
      stack: this.stack,
      context: this.context,
    };
  }

  override toString(): string {
    return JSON.stringify(this, null, " ");
  }
}
